export default {

  get speechRecognition() { return window.plugins.speechRecognition },

  hasPermission() {
    return new Promise((resolve, reject) => this.speechRecognition.hasPermission(resolve, reject))
  },

  requestPermission() {
    return new Promise((resolve, reject) => this.speechRecognition.requestPermission(resolve, reject))
  },

  getSupportedLanguages() {
    return new Promise((resolve, reject) => this.speechRecognition.getSupportedLanguages(resolve, reject))
  },

  isRecognitionAvailable() {
    return new Promise((resolve, reject) => this.speechRecognition.isRecognitionAvailable(resolve, reject))
  },

  /**
   * Not promise based so that we can support partial results
   */
  start(onResult, onError, settings) {
    return this.speechRecognition.startListening(onResult, onError, settings)
  },

  stop() {
    return new Promise((resolve, reject) => this.speechRecognition.stopListening(resolve, reject))
  }
}